<sl-title title="Purchase Order Setup"></sl-title>
<div class="po-setup-page-container">
	<div class="row" *ngIf="sites?.length">
		<div class="col-xs-4">
			<mat-form-field class="full-width">
				<mat-label>Site</mat-label>
				<mat-select [(ngModel)]="siteId" (ngModelChange)="onSiteIdChanged()" name="siteId" [disabled]="poSetupForm.dirty">
					<mat-option *ngFor="let site of sites; trackById" [value]="site.Id">{{ site.SiteCode }}: {{ site.SiteName }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
	<form #poSetupForm="ngForm" (ngSubmit)="poSetupForm.valid && save()">
		<mat-card class="linq-card--legacy" *ngIf="entity">
			<mat-card-content>
				<div class="row">
					<div class="col-sm-6 col-md-3">
						<div>
							<mat-checkbox [(ngModel)]="entity.AllowBackDatedPO" color="primary" name="AllowBackDatedPO" #AllowBackDatedPO="ngModel"
								[disabled]="isReadOnly">Allow back dated POs</mat-checkbox>
						</div>
						<div>
							<mat-checkbox [(ngModel)]="entity.ShowOverBudgetWarnings" color="primary" name="ShowOverBudgetWarnings"
								#ShowOverBudgetWarnings="ngModel" [disabled]="isReadOnly">Show over budget warnings</mat-checkbox>
						</div>
						<div>
							<mat-checkbox [(ngModel)]="entity.SendPOAttachmentsWithEmail" color="primary" name="SendPOAttachmentsWithEmail"
								#sendPoWithEmail="ngModel" [disabled]="isReadOnly">Always Send Attachment with Emails</mat-checkbox>
						</div>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Next PO Number</mat-label>
							<input matTooltip="Next PO Number" matTooltipShowDelay="1000" matInput name="NextPONumber" #NextPONumber="ngModel"
								[(ngModel)]="entity.NextPONumber" inputmode="numeric" numbersOnly [allowDecimals]="false" maxlength="9"
								[disabled]="isReadOnly" />
						</mat-form-field>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Next Requisition Number</mat-label>
							<input matTooltip="Next Requisition Number" matTooltipShowDelay="1000" matInput name="NextRequisitionNumber"
								#NextRequisitionNumber="ngModel" [(ngModel)]="entity.NextRequisitionNumber" inputmode="numeric" numbersOnly
								[allowDecimals]="false" maxlength="9" [disabled]="isReadOnly" />
						</mat-form-field>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Max Dollar Amount</mat-label>
							<input matTooltip="Max Dollar Amount" matTooltipShowDelay="1000" matInput name="MaxPOAmount" #MaxPOAmount="ngModel"
								[(ngModel)]="entity.MaxPOAmount" inputmode="numeric" numbersOnly maxlength="10" [disabled]="isReadOnly" />
						</mat-form-field>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Percent Over Budget Allowed</mat-label>
							<input matTooltip="Percent Over Budget Allowed" matTooltipShowDelay="1000" matInput name="PercentOverBudgetAllowed"
								#PercentOverBudgetAllowed="ngModel" [(ngModel)]="entity.PercentOverBudgetAllowed" inputmode="numeric" numbersOnly
								maxlength="10" [disabled]="isReadOnly" />
							<span matSuffix>%</span>
						</mat-form-field>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Number of Copies</mat-label>
							<mat-select matTooltip="Number of Copies" matTooltipShowDelay="1000" [(ngModel)]="entity.NumberOfCopies"
								name="NumberOfCopies" #NumberOfCopies="ngModel" (ngModelChange)="numberOfCopiesChanged()" [disabled]="isReadOnly">
								<mat-option *ngFor="let copyNumber of copies; trackByItem" [value]="copyNumber">{{ copyNumber }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Copy to Email as Receipt</mat-label>
							<mat-select matTooltip="Copy to Email as Receipt" matTooltipShowDelay="1000" [(ngModel)]="entity.EmailReceiptCopyNumber"
								name="EmailReceiptCopyNumber" #EmailReceiptCopyNumber="ngModel" [disabled]="isReadOnly">
								<mat-option *ngFor="let copyNumber of copies; trackByItem" [value]="copyNumber">{{ copyNumber }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-sm-6 col-md-3">
						<mat-form-field>
							<mat-label>Email Source</mat-label>
							<input matTooltip="Email Source" matTooltipShowDelay="1000" type="text" matInput [matAutocomplete]="auto"
								[(ngModel)]="entity.SourceEmailAddress" name="SourceEmailAddress" #SourceEmailAddress="ngModel" maxlength="100" email
								[disabled]="isReadOnly" />
							<mat-autocomplete #auto="matAutocomplete">
								<mat-option *ngFor="let email of filteredUserEmails | async; trackByItem" [value]="email">
									{{ email }}
								</mat-option>
							</mat-autocomplete>
							<mat-error *ngIf="SourceEmailAddress.errors?.email">Invalid email address</mat-error>
						</mat-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<h4>Logo</h4>
						<sl-file-upload [uploadedFile]="{ fileBase64Encoded: entity.Logo }" isImage="true" (fileUploaded)="logoChangeEvent($event)"
							[isReadOnly]="isReadOnly">
						</sl-file-upload>
					</div>
					<div class="col-sm-6">
						<h4>Terms &amp; Conditions</h4>
						<sl-file-upload [allowedExtensions]="['.pdf']"
							[uploadedFile]="{ fileName: entity.TermsFileType, fileBase64Encoded: entity.TermsBinary }"
							(fileUploaded)="termsChangeEvent($event)" [isReadOnly]="isReadOnly"></sl-file-upload>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="linq-card--legacy stacked" *ngIf="entity">
			<mat-card-content>
				<mat-tab-group dynamicHeight class="linq-tab-bar">
					<mat-tab label="{{ copy.CopyNumber === 1 ? 'Vendor' : 'Copy ' + copy.CopyNumber }}"
						*ngFor="let copy of entity.SitePOSetupCopies; index as index; trackById">
						<button type="button" mat-raised-button color="primary" class="pull-right" [disabled]="poSetupForm.dirty || !copy.Id"
							[title]="poSetupForm.dirty ? 'Save changes before previewing' : ''" (click)="getPreview(copy.CopyNumber)">
							Preview
						</button>
						<div class="clear"></div>
						<div class="row">
							<div class="col-xs-12 linq-mt-5">
								<mat-form-field class="full-width">
									<mat-label>Comments</mat-label>
									<textarea matInput [(ngModel)]="copy.Comments" [name]="'Comments-' + index" #Comments="ngModel"
										[disabled]="isReadOnly"></textarea>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-6">
								<h4>Left Signature</h4>
								<div>
									<mat-checkbox [(ngModel)]="copy.SigLeftShow" color="primary" [name]="'SigLeftShow-' + index"
										#SigLeftShow="ngModel" [disabled]="isReadOnly">Show
									</mat-checkbox>
								</div>
								<sl-file-upload [uploadedFile]="{ fileBase64Encoded: copy.SigLeftImg }" isImage="true"
									(fileUploaded)="leftSignatureChangeEvent(copy, $event)" [isReadOnly]="isReadOnly"></sl-file-upload>
							</div>
							<div class="col-sm-6">
								<h4>Right Signature</h4>
								<div>
									<mat-checkbox [(ngModel)]="copy.SigRightShow" color="primary" [name]="'SigRightShow-' + index"
										#SigRightShow="ngModel" [disabled]="isReadOnly">
										Show
									</mat-checkbox>
								</div>
								<sl-file-upload [uploadedFile]="{ fileBase64Encoded: copy.SigRightImg }" isImage="true"
									(fileUploaded)="rightSignatureChangeEvent(copy, $event)" [isReadOnly]="isReadOnly"></sl-file-upload>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-6">
								<mat-form-field>
									<mat-label>Job Title of Signee</mat-label>
									<input matTooltip="Job Title of Signee" matTooltipShowDelay="1000" matInput [name]="'SigLeftText-' + index"
										#SigLeftText="ngModel" [(ngModel)]="copy.SigLeftText" maxlength="100" [disabled]="isReadOnly" />
								</mat-form-field>
							</div>
							<div class="col-sm-6">
								<mat-form-field>
									<mat-label>Job Title of Signee</mat-label>
									<input matTooltip="Job Title of Signee" matTooltipShowDelay="1000" matInput [name]="'SigRightText-' + index"
										#SigRightText="ngModel" [(ngModel)]="copy.SigRightText" maxlength="100" [disabled]="isReadOnly" />
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<mat-form-field class="full-width">
									<mat-label>Footer</mat-label>
									<textarea matInput [name]="'Footer-' + index" [(ngModel)]="copy.Footer" #Footer="ngModel"
										[disabled]="isReadOnly"></textarea>
								</mat-form-field>
							</div>
						</div>
					</mat-tab>
				</mat-tab-group>
			</mat-card-content>
		</mat-card>
		<sl-button-bar *ngIf="poSetupForm.dirty && !isReadOnly" (canceled)="cancelChanges()"></sl-button-bar>
	</form>
</div>